module.exports = __webpack_public_path__ + "img/top_bar.c3b5fece.png";